// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__FH5Ta","contents":"Overlay_contents__vGQto"};